import { Breadcrumb, Skeleton, Row, Col, DatePicker, Select, Divider } from 'antd';
import { ButtonAction, Card, Form, FormItem, GetValidateFields, Input, Toggle, Confirm, Button } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAction from '@pages/users/hooks/useAction';
import roleGroupAction from '@pages/role-groups/hooks/useAction';
import moment from "moment";
import { IResponseRoleGroups } from '@interfaces/iresponse-role-group';
import { IResponseCountry } from '@interfaces/iresponse-country';
import { IResponseProvince } from '@interfaces/iresponse-province';
import { IResponseCity } from '@interfaces/iresponse-city';

const { Option } = Select;
export const PageUsersFormComponent = (props: any) => {
    // set header page
    const title = 'Users'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getDetail, postData, updateData, detail, getCountries, countries, getProvinces, provinces, getCities, cities } = useAction();
    const { getData: getDataRoleGroup, data: dataRoleGroup } = roleGroupAction();
    const { match } = props;
    const idData = match.params.id;

    // initiate form data
    const initialFieldsValues: any = {
        email: null,
        firstName: null,
        lastName: null,
        dateOfBirth: null,
        address: null,
        countryId: null,
        provinceId: null,
        cityId: null,
        postalCode: null,
        phoneNumber: null,
        roleGroupId: null
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});

    // first load
    useEffect(() => {
        getDataRoleGroup({ all: true });
        getCountries({ all: true });
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
        }
    }, [detail])

    const fetchProvince = (countryId: string) => {
        getProvinces({ all: true, countryId });
    }

    const fetchCity = (provinceId: string) => {
        getCities({ all: true, provinceId });
    }

    // fetch data
    const setDefault = async () => {
        if (detail) {
            if (detail.country.id) {
                fetchProvince(detail.country.id);
            }

            if (detail.province.id) {
                fetchCity(detail.province.id);
            }
            setFieldsValues({
                active: detail.active,
                email: detail.email,
                firstName: detail.firstName,
                lastName: detail.lastName,
                dateOfBirth: detail.dateOfBirth,
                address: detail.address,
                countryId: detail.country.id,
                provinceId: detail.province.id,
                cityId: detail.city.id,
                postalCode: detail.postalCode,
                phoneNumber: detail.phoneNumber,
                roleGroupId: detail.roleGroup.id ?? null,
                roles: detail.roles.map((role: any) => role.name)
            });
        }
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const validateFields = GetValidateFields(fieldsValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            let val: any = values;
            val = {
                ...val,
                active: fieldsValues.active ?? false,
                dateOfBirth: fieldsValues.dateOfBirth ? moment(fieldsValues.dateOfBirth).format() : null
            };
            setParamSubmit(val);
            setShowConfirm(true);
        }
    };

    const changeDate = (value: any) => {
        setFieldsValues({ ...fieldsValues, dateOfBirth: value ? value.format() : null });
    }

    const changeCountry = (value: string) => {
        fetchProvince(value);
        setFieldsValues({ ...fieldsValues, countryId: value });
    }

    const changeProvince = (value: string) => {
        fetchCity(value)
        setFieldsValues({ ...fieldsValues, provinceId: value });
    }

    const changeCity = (value: string) => {
        setFieldsValues({ ...fieldsValues, cityId: value });
    }

    const changeRoleGroup = (value: string) => {
        setFieldsValues({ ...fieldsValues, roleGroupId: value });
    }

    const rolesChange = (value: string) => {
        setFieldsValues({ ...fieldsValues, roles: value });
    }

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="First Name" labelAlign="left"
                                            fieldDecorator={{
                                                label: "firstName",
                                                rules: [{
                                                    message: 'Please input first name',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="firstName" defaultValue={fieldsValues.firstName} />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Last Name" labelAlign="left"
                                            fieldDecorator={{
                                                label: "lastName"
                                            }}
                                        >
                                            <Input id="lastName" defaultValue={fieldsValues.lastName} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Email" labelAlign="left"
                                            fieldDecorator={{
                                                label: "email",
                                                rules: [{
                                                    message: 'Please input email',
                                                    required: true,
                                                },
                                                {
                                                    type: 'email',
                                                    message: "That doesn't look like an email address",
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="email" defaultValue={fieldsValues.email} />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Phone Number" labelAlign="left"
                                            fieldDecorator={{
                                                label: "phoneNumber",
                                                rules: [{
                                                    message: 'Please input phone number',
                                                    required: true,
                                                },
                                                {
                                                    type: 'number',
                                                    message: "That doesn't look like an phone number",
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="phoneNumber" defaultValue={fieldsValues.phoneNumber} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Active" labelAlign="left"
                                            fieldDecorator={{
                                                label: "active"
                                            }}
                                        >
                                            <Toggle id="active" defaultChecked={fieldsValues.active} />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Role Group" labelAlign="left"
                                            fieldDecorator={{
                                                label: "roleGroupId"
                                            }}
                                        >
                                            <Select defaultValue={fieldsValues.roleGroupId} showSearch value={fieldsValues.roleGroupId} optionFilterProp="children" style={{ width: "100%" }} onChange={changeRoleGroup}>
                                                {dataRoleGroup.map((roleGroup: IResponseRoleGroups) => <Option key={roleGroup.id} value={roleGroup.id}>{roleGroup.name}</Option>)}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row style={{ display: idData ? 'block' : 'none' }}>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Akses" labelAlign="left"
                                            fieldDecorator={{
                                                label: "roles"
                                            }}
                                        >
                                            <Select optionFilterProp="children" defaultValue={fieldsValues.roles} style={{ width: "100%" }} mode="multiple" tokenSeparators={[',']} onChange={rolesChange}>
                                                <Option key="Admin" value="Admin">CMS</Option>
                                                <Option key="User" value="User">YourMedia</Option>
                                                <Option key="Guest" value="Guest">Guest</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Divider orientation="center" style={{ color: "#D84E70", marginTop: "20px", marginBottom: "20px" }}>Additional Info</Divider>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Address" labelAlign="left"
                                            fieldDecorator={{
                                                label: "address",
                                            }}
                                        >
                                            <textarea className="asumsi-input" style={{ height: "98px" }} id="address" defaultValue={fieldsValues.address} />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Birth Date" labelAlign="left"
                                            fieldDecorator={{
                                                label: "dateOfBirth",
                                            }}
                                        >
                                            <DatePicker defaultValue={fieldsValues.dateOfBirth ? moment(fieldsValues.dateOfBirth) : null} onChange={changeDate} id="dateOfBirth" format="DD MMM YYYY" />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Country" labelAlign="left"
                                            fieldDecorator={{
                                                label: "countryId"
                                            }}
                                        >
                                            <Select defaultValue={fieldsValues.countryId} showSearch optionFilterProp="children" style={{ width: "100%" }} onChange={changeCountry}>
                                                {countries ? countries.map((country: IResponseCountry) => <Option key={country.id} value={country.id}>{country.name}</Option>) : null}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Province" labelAlign="left"
                                            fieldDecorator={{
                                                label: "provinceId"
                                            }}
                                        >
                                            <Select defaultValue={fieldsValues.provinceId} showSearch optionFilterProp="children" style={{ width: "100%" }} onChange={changeProvince}>
                                                {provinces ? provinces.map((province: IResponseProvince) => <Option key={province.id} value={province.id}>{province.name}</Option>) : null}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="City" labelAlign="left"
                                            fieldDecorator={{
                                                label: "cityId"
                                            }}
                                        >
                                            <Select defaultValue={fieldsValues.cityId} showSearch optionFilterProp="children" style={{ width: "100%" }} onChange={changeCity}>
                                                {cities ? cities.map((city: IResponseCity) => <Option key={city.id} value={city.id}>{city.name}</Option>) : null}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="30%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Postal Code" labelAlign="left"
                                            fieldDecorator={{
                                                label: "postalCode",
                                                rules: [
                                                    {
                                                        type: 'number',
                                                        message: "That doesn't look like an postal code",
                                                    }
                                                ]
                                            }}
                                        >
                                            <Input id="postalCode" defaultValue={fieldsValues.postalCode} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        left={
                            <Link to="/user/users">
                                <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                            </Link>
                        }
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    if (!idData) {
                        // do post data
                        postData(paramSubmit);
                    } else {
                        // do update data
                        updateData(paramSubmit, idData);
                    }
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS>
    );
};
export default PageUsersFormComponent;



// WEBPACK FOOTER //
// ./src/pages/users-form/component.tsx